
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LessonCreateDto } from '../../Manipulate/CoursesObjects/LessonDto';

@Injectable({
  providedIn: 'root'
})
export class LessonService {
  private apiUrl = environment.apiUrl + '/lesson';

  constructor(private http: HttpClient) { }

  public GetLessonMaterials(courseId:string, lessonId:string) : Observable<any>{
    return this.http.get(`${this.apiUrl}/material/${courseId}/${lessonId}`);
  }
  public GetLessonsByModule(moduleId:string): Observable<any>{
    return this.http.get(`${this.apiUrl}/byModule/${moduleId}`);
  }
  public AddLesson(dto:LessonCreateDto) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}`,dto);
  }
  public PostMaterial(courseId:string, lessonId:string, materialFile:FormData) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/material/${courseId}/${lessonId}`,materialFile);
  }
  public UpdateOrderByLesson(newOrder:number, orderId:string) : Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/updateOrderByLesson/${newOrder}/${orderId}`,'');
  }
  public Delete(lessonId: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${lessonId}`);
  }


}
